import MidiaComponent from './midia.component'

export default MidiaComponent
